export default __webpack_public_path__ + "static/media/CNo.15-3.cf86bc5b.jpg";